import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';

function ProtectedRoute({ children }) {
  const { isConnected, connectWallet, loading } = useWallet();

  if (!isConnected) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Wallet Connection Required</h2>
          <p className="text-gray-600 mb-6">Please connect your wallet to access this feature.</p>
          <button
            onClick={connectWallet}
            disabled={loading}
            className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute; 